import { useState } from "react";
import ImageViewer from "../../Components/modern/ImageViewer";
import { Container, SectionHeading } from "../../Components/modern/UI";
import { newsItems } from "../../Data/mediaData";

export default function News() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <>
      <section aria-labelledby="sn-news-list" className="sn-py-12 md:sn-py-16">
        <Container>
          <div className="sn-mb-8 sn-max-w-3xl">
            <SectionHeading eyebrow="In the news" id="sn-news-list">Press coverage.</SectionHeading>
          </div>

          <article className="sn-mb-8 sn-overflow-hidden sn-rounded-card sn-border sn-border-line sn-bg-white sn-shadow-soft">
            <div className="sn-grid sn-gap-0 lg:sn-grid-cols-[0.9fr_1.1fr] lg:sn-items-stretch">
              <div className="sn-p-6 md:sn-p-8">
                <p className="sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] sn-text-leaf">START UP CHAMPIONS</p>
                <h2 className="sn-mt-3 sn-font-display sn-text-2xl sn-leading-tight sn-text-forest">AGRO ANVESANA | EP - 46</h2>
                <p className="sn-mt-3 sn-text-sm sn-leading-relaxed sn-text-muted">12.04.2026 | 9:30pm | DD Chandana</p>
              </div>
              <div className="sn-bg-ink">
                <iframe
                  className="sn-block sn-aspect-video sn-h-full sn-min-h-[260px] sn-w-full"
                  src="https://www.youtube.com/embed/MRdn9UFVYWY"
                  title="START UP CHAMPIONS AGRO ANVESANA EP 46 DD Chandana"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>
            </div>
          </article>

          <div className="sn-grid sn-gap-6 lg:sn-grid-cols-2">
            {newsItems.map((item, index) => (
              <article key={item.id} className="sn-overflow-hidden sn-rounded-card sn-border sn-border-line sn-bg-white sn-shadow-soft">
                <button
                  type="button"
                  onClick={() => setActiveIndex(index)}
                  className="sn-block sn-w-full sn-text-left"
                  aria-label={`Open ${item.title}`}
                >
                  <span className="sn-block sn-aspect-[4/3] sn-overflow-hidden sn-bg-sage">
                    <img src={item.src} alt={item.alt} loading={index === 0 ? "eager" : "lazy"} className="sn-h-full sn-w-full sn-object-contain sn-p-3 sn-mix-blend-multiply" />
                  </span>
                  <span className="sn-block sn-p-6">
                    <span className="sn-block sn-font-display sn-text-2xl sn-leading-tight sn-text-forest">{item.title}</span>
                  </span>
                </button>
              </article>
            ))}
          </div>
        </Container>
      </section>

      <ImageViewer items={newsItems} activeIndex={activeIndex} onClose={() => setActiveIndex(null)} onChange={setActiveIndex} title="News clipping" />
    </>
  );
}
